import { Grid, Typography, Box } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import { withStyles } from '@material-ui/styles';
import parse from 'html-react-parser';

import FormPhone from '../../../FormPhone';
import { StyledButton } from '../../../styles';
import Footer from '../../../../components/Rodape/Footer';
import { TemplateProps } from '../../types';

const styles = (theme: any) => ({
  button: {
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  leftIcon: {
    marginRight: theme.spacing(),
  },
  rightIcon: {
    marginLeft: 'auto',
  },
  imgLogo: {
    margin: theme.spacing(),
  },
});

interface Props extends TemplateProps {
  classes?: any;
}

function Classico({
  classes,
  carteira,
  contatos,
  telValue,
  mensagem,
  callbackAberto,
  onSelectContato,
  onChangeTel,
  onSubmitTel,
}: Props) {
  return (
    <>
      <Grid container alignItems="center">
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ margin: 10, padding: 5, height: '100%' }}
        >
          <Grid container justifyContent="center" alignItems="center" direction="column">
            <Box display="flex" flexDirection="row" width="100%" mb={3}>
              <img
                width={290}
                src={carteira.urlLogoLandingPage}
                alt="Logotipo da Bellinati Perez Digital"
                style={{ margin: '0 auto' }}
              />
            </Box>
            <Box
              style={{ padding: '2%', textAlign: 'center' }}
              display="flex"
              flexDirection="row"
              mb={1}
            >
              <Typography variant="h5">{parse(carteira.titulo ?? '')}</Typography>
            </Box>
            <Box
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              {!callbackAberto ? (
                contatos.map((contato) => (
                  <Box
                    key={contato.descricao}
                    display="flex"
                    flexDirection="row"
                    width="95%"
                    mb={-1}
                    mt={-0.5}
                  >
                    <StyledButton
                      backgroundColor={carteira.corBase}
                      // Comportamento de cada botão
                      onClick={() => onSelectContato(contato)}
                    >
                      <Icon className={classes.leftIcon} style={{ color: carteira.corTexto }}>
                        {contato.imageUrl?.split('-')[1]}
                      </Icon>
                      <span style={{ color: carteira.corTexto }}>{contato.descricao}</span>
                      <Icon className={classes.rightIcon}>chevron_right</Icon>
                    </StyledButton>
                  </Box>
                ))
              ) : (
                <>
                  <FormPhone onSubmit={onSubmitTel} value={telValue} onChange={onChangeTel} />
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    width="100%"
                    margin="auto"
                    mb={-1}
                    mt={-0.5}
                  >
                    <Typography variant="h6">{mensagem && <span>{mensagem}</span>}</Typography>
                  </Box>
                </>
              )}
            </Box>
            <Box mt={2}>
              <Typography variant="h5">{carteira.subTitulo}</Typography>
            </Box>

            {!!carteira.urlLogoCliente && (
              <Box display="flex" flexDirection="row" width="100%" mb={4} mt={3}>
                <img
                  className="imgLogoCliente"
                  src={carteira.urlLogoCliente}
                  alt="Logotipo UrlLogoCliente"
                  style={{ margin: '0 auto', maxWidth: '300px' }}
                />
              </Box>
            )}

            <Box display="flex" flexDirection="row" width="auto" minWidth="280px">
              <img
                className="imgBp"
                src="https://comunicacao.bp.com.vc/img/bp-logo.png"
                alt="logo estática bp"
                style={{ margin: 'auto', width: '100px', position: 'relative' }}
              />

              <img
                className="imgLogo"
                src={carteira.urlLogoClienteBase64 || carteira.urlLogo}
                alt="Logotipo Bellinati Perez + Parceria"
                style={{ margin: 'auto', maxWidth: '350px', position: 'relative' }}
              />
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Footer />
    </>
  );
}

export default withStyles(styles)(Classico);
